<script>
    import { apiUrl, debounce } from "@/utils";
    import BaseInput from "@main/packages/BaseInput";

    export default {
        name: "GiftTemplate",
        components: {
            BaseInput,
        },
        props: {
            amount: String,
            templates: Array,
            activeTemplate: Object,
        },
        data() {
            return {
                amountValue: "",
            };
        },
        watch: {
            amountValue: debounce(function (amount) {
                if (amount.length === 0 || parseInt(amount) < 1000) {
                    amount = "1000";
                }
                if (parseInt(amount) > 149000) {
                    // amount = "149000";
                    this.amountValue = "149000";
                }
                this.$emit("on-select-amount", amount);
            }, 1000),
        },
        computed: {
            amountsList() {
                return ["1000", "2000", "3000", "5000", "10000", "15000"];
            },
        },
        methods: {
            apiUrl,
            onSelectTemplate(id) {
                this.$emit("on-select-template", id);
            },
        },
    };
</script>

<template>
    <section class="gift-template gift-section">
        <div class="gift-template-amount">
            <h2 class="gift-section__title">
                Выберите внешний вид и&nbsp;номинал сертификата
            </h2>
            <div class="gift-section__text">
                Мы&nbsp;отправим письмо получателю с&nbsp;выбранным дизайном
            </div>

            <div class="gift-template-amount__list">
                <button
                    v-for="amountNumber in amountsList"
                    :key="amountNumber"
                    class="gift-template-amount__button"
                    :class="{ 'is-active': amountNumber === amount }"
                    @click="$emit('on-select-amount', amountNumber)"
                >
                    {{ amountNumber }}
                </button>

                <base-input
                    v-model="amountValue"
                    class="gift-template-amount__input"
                    type="number"
                    variant="secondary"
                    :min="1000"
                    :max="149000"
                    placeholder="Своя сумма от 1000 ₽ до 149 000 ₽"
                ></base-input>
            </div>
        </div>

        <div class="gift-template-certificates">
            <div v-if="activeTemplate" class="gift-template-certificates__selected">
                <img :src="apiUrl(activeTemplate.image)" alt="" />
            </div>
            <div v-if="templates" class="gift-template-certificates__list">
                <button
                    v-for="template in templates"
                    :key="template.id"
                    class="gift-template-certificates__item"
                    :class="{ 'is-active': template.id === activeTemplate.id }"
                    @click="$emit('on-select-template', template.id)"
                >
                    <img :src="apiUrl(template.image)" alt="" />
                </button>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    .gift-template {
        @include bp($bp-desktop-sm) {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    .gift-template-amount {
        margin-bottom: 30px;
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            flex-basis: 480px;
            max-width: 480px;
            margin-bottom: 0;
        }
    }

    .gift-template-amount__list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -5px;
        @include bp($bp-desktop-sm) {
            max-width: 360px;
        }
    }

    .gift-template-amount__input {
        margin: 0 5px;
    }

    .gift-template-amount__button {
        flex-basis: calc(33.3333% - 10px);
        max-width: calc(33.3333% - 10px);
        margin: 0 5px 10px;
        padding: 10px 14px;
        color: var(--primary-text);
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        background-color: #fff;
        border: 2px solid #fff;
        border-radius: 10px;
        transition: color 0.2s ease-in, background-color 0.2s ease-in,
            border-color 0.2s ease-in;
        &:hover {
            border-color: var(--primary);
        }
        &.is-active {
            color: #fff;
            background-color: var(--primary);
            border-color: var(--primary);
        }
    }

    .gift-template-certificates {
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            flex-basis: 400px;
            max-width: 400px;
        }
        @include bp($bp-desktop-lg) {
            flex-basis: 480px;
            max-width: 480px;
        }
    }

    .gift-template-certificates__selected {
        position: relative;
        margin-bottom: 20px;
        padding-bottom: 62.8%;
        background-color: #fff;
        border-radius: 30px;
        img {
            @include center-absolute(0);
        }
    }

    .gift-template-certificates__list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -5px -10px;
    }

    .gift-template-certificates__item {
        position: relative;
        flex-basis: calc(33.3333% - 10px);
        max-width: calc(33.3333% - 10px);
        margin: 0 5px 10px;
        opacity: 0.5;
        transition: opacity 0.2s ease-in;
        &::before {
            content: "";
            display: block;
            padding-bottom: 64%;
        }
        img {
            @include center-absolute(0);
            pointer-events: none;
        }
        &:hover,
        &.is-active {
            opacity: 1;
        }
        @include bp($bp-desktop-sm) {
            flex-basis: calc(25% - 10px);
            max-width: calc(25% - 10px);
        }
    }
</style>
